/**
 * @ngdoc directive
 * @name Scroll Level
 *
 * @description
 Add class to block if scroll below
 *
 * @example
 <div class='clearfix' scroll-level scroll-level-class='custom-class'>Some content</div>
 */

(function() {
    'use strict';

    directive.$inject = ["$window"];
    app.directive('scrollLevel', directive);

    function directive($window) {
        return {
          link: link,
          restrict: 'A',
          scope: {
            scrollLevelClass: '@?'
          }
        };

        function link($scope, $element) {
          var win = angular.element($window);
          var elementOffsetTop = $element.offset().top;
          var scrollLevelClass = $scope.scrollLevelClass || 'is-below';

          win.on('scroll', function () {
            if (win.scrollTop() >= elementOffsetTop) {
              $element.addClass(scrollLevelClass);
            } else {
              $element.removeClass(scrollLevelClass);
            }
          });
        }
    }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/scrollLevelDirective.js